(function () {
  angular
    .module("akitabox.mobile")
    .config(coreConfig)
    .config(mdConfig)
    .factory("httpInterceptor", httpInterceptor);

  /** @ngInject */
  function coreConfig($httpProvider, $sceDelegateProvider, storeProvider) {
    $httpProvider.interceptors.push("httpInterceptor");
    // Whitelist resource urls
    $sceDelegateProvider.resourceUrlWhitelist(["self"]);
    // Configure storage
    storeProvider.setStore("localStorage");
  }

  /* @ngInject */
  function httpInterceptor($injector, $location, EnvService) {
    var service = {
      responseError: responseError,
    };
    return service;

    function responseError(response) {
      var $q = $injector.get("$q");
      var $state = $injector.get("$state");
      var accountId = response.config.url.split("/")[3];
      var buildingId = response.config.url.split("/")[4];

      switch (response.status) {
        case 401:
          if (response.config.url === `${EnvService.getApiUrl()}/identity`) {
            // we're just poking around here to see if user is logged in, we don't want these requests to trigger redirects
            // this is a specific request to check if the user is logged in
            return $q.reject(response);
          } else if ($state.current.name !== "auth.login") {
            const qs = new URLSearchParams($location.search()).toString();
            const redirect_url = `${$location.protocol()}://${$location.host()}${$location.path()}${
              qs ? `?${qs}` : ""
            }`;
            $state.go("auth.logout", { redirect_url });
          }
          break;
        case 402:
          $state.go("app.building.detail", {
            accountId: accountId,
            buildingId: buildingId,
          });
          break;
        case 503:
          $state.go("root.503");
          break;
        default:
          break;
      }

      return $q.reject(response);
    }
  }

  /** @ngInject */
  function mdConfig($provide, $mdThemingProvider) {
    // Decorators
    $provide.decorator(
      "mdAutocompleteDirective",
      MdAutoCompleteDirectiveDecorator
    );
    // Themes
    $mdThemingProvider.definePalette("black", {
      50: "#E4E4E4",
      100: "#BCBCBC",
      200: "#909090",
      300: "#646464",
      400: "#424242",
      500: "#212121",
      600: "#1D1D1D",
      700: "#181818",
      800: "#141414",
      900: "#0B0B0B",
      A100: "#FFFFFF",
      A200: "#FAFAFA",
      A400: "#F5F5F5",
      A700: "#EEEEEE",
      contrastDefaultColor: "light",
      contrastDarkColors: "50 100 200 A100 A200 A400 A700",
    });
    $mdThemingProvider.definePalette("sunglow", {
      50: "#fffae7",
      100: "#fff3c2",
      200: "#ffec9a",
      300: "#ffe472",
      400: "#ffde53",
      500: "#ffd835",
      600: "#ffd430",
      700: "#ffce28",
      800: "#ffc822",
      900: "#ffbf16",
      A100: "#ffffff",
      A200: "#fffefc",
      A400: "#ffefc9",
      A700: "#ffe7af",
      contrastDefaultColor: "light",
      contrastDarkColors: [
        "50",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900",
        "A100",
        "A200",
        "A400",
        "A700",
      ],
    });
    $mdThemingProvider.definePalette("midnight", {
      50: "#e4e5e7",
      100: "#bcbec4",
      200: "#90939d",
      300: "#646775",
      400: "#424758",
      500: "#21263a",
      600: "#1d2234",
      700: "#181c2c",
      800: "#141725",
      900: "#0b0d18",
      A100: "#64B5F6",
      A200: "#2196F3",
      A400: "#1976D2",
      A700: "#0D47A1",
      contrastDefaultColor: "light",
      contrastDarkColors: "50 100 200",
      contrastLightColors: [
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900",
        "A100",
        "A200",
        "A400",
        "A700",
      ],
    });
    $mdThemingProvider.definePalette("deep-red", {
      50: "#FCf8f8",
      100: "#E7C2C1",
      200: "#D79A99",
      300: "#C36765",
      400: "#BA514F",
      500: "#A94442",
      600: "#933B39",
      700: "#7D3231",
      800: "#672928",
      900: "#512120",
      A100: "#FCEEEE",
      A200: "#EF9795",
      A400: "#D1504D",
      A700: "#A94442",
      contrastDefaultColor: "light",
      contrastDarkColors: "50 100 200 300 A100 A200",
    });
    $mdThemingProvider
      .theme("default")
      .primaryPalette("sunglow")
      .accentPalette("midnight")
      .warnPalette("deep-red")
      .backgroundPalette("grey", {
        default: "200",
      });
    $mdThemingProvider
      .theme("black")
      .primaryPalette("black")
      .accentPalette("black")
      .warnPalette("deep-red");
    $mdThemingProvider
      .theme("dark")
      .primaryPalette("midnight")
      .accentPalette("sunglow", {
        default: "500",
      })
      .warnPalette("deep-red");
  }

  /* @ngInject */
  function MdAutoCompleteDirectiveDecorator($delegate, $timeout) {
    var directive = $delegate[0];
    var compile = directive.compile;

    // Extend compile function
    directive.compile = function () {
      // Run the original compile function
      var link = compile.apply(this, arguments);

      // Return new link function
      return function (scope, element) {
        // Don't do anything if not placeholder
        if (!scope.placeholder) return link;

        // Run the original link function
        link.apply(this, arguments);

        /*
          Wrap code within $timeout to force the excecution to be made
          after ngIf runs

          Without this walkaround inputContainer
          and input elements doesn't exists yet in DOM
        */
        $timeout(function () {
          var inputContainer = element.find("md-input-container");
          var input = inputContainer.find("input");

          // Show the placeholder and send the label away
          inputContainer.toggleClass("md-input-has-placeholder");
          input.attr("placeholder", scope.placeholder);
        });
      };
    };

    return $delegate;
  }
})();
